import React, { useState } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { foundations as f } from '../../data/programDetails';

export default function FoundationsPillars() {
  const [active, setActive] = useState(f.pillars[0].id);
  const p = f.pillars.find((x) => x.id === active);
  return (
    <section className="pb-8" data-testid="foundations-pillars">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" role="tablist">
          {f.pillars.map((x) => {
            const on = x.id === active;
            return (
              <button
                key={x.id}
                type="button"
                role="tab"
                aria-selected={on}
                onClick={() => setActive(x.id)}
                data-testid={`foundations-pillar-${x.id}`}
                className={`rounded-2xl text-center py-5 px-3 font-display font-bold text-lg md:text-xl transition-colors flex flex-col items-center gap-1 ${on ? 'bg-splash-coral text-white shadow-lg' : 'bg-splash-green text-white hover:bg-splash-greenDark'}`}
              >
                {x.title}
                <ChevronDown className={`w-4 h-4 transition-transform ${on ? 'rotate-180' : 'opacity-70'}`} />
              </button>
            );
          })}
        </div>
        <div key={p.id} className="mt-4 rounded-3xl bg-white border border-splash-sand p-6 md:p-8 fade-up" data-testid="foundations-pillar-detail">
          <h3 className="font-display font-bold text-2xl md:text-3xl text-splash-green">{p.title}</h3>
          <p className="mt-2 text-splash-green/85 font-semibold">{p.lead}</p>
          <ul className="mt-5 grid md:grid-cols-2 gap-3">
            {p.points.map((pt) => (
              <li key={pt} className="flex gap-3 text-splash-green/85"><Check className="w-5 h-5 text-splash-teal shrink-0 mt-0.5" /> {pt}</li>
            ))}
          </ul>
          <p className="mt-5 text-splash-coralDark font-semibold">{p.close}</p>
        </div>
      </div>
    </section>
  );
}
